import { ensureActive17z6c489wymmv as ensureActive } from './Emitters.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NopCollector_instance46vt84er03h7 as NopCollector_instance } from './internal/NopCollector.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *emitAll(_this__u8e3s4, flow, $completion) {
  ensureActive(_this__u8e3s4);
  yield* flow.a1d(_this__u8e3s4, $completion);
  return Unit_instance;
}
function *collect(_this__u8e3s4, $completion) {
  return yield* _this__u8e3s4.a1d(NopCollector_instance, $completion);
}
//region block: exports
export {
  collect as collect8rtp7i1ebpj9,
  emitAll as emitAll14ajoawrvg9d0,
};
//endregion

//# sourceMappingURL=Collect.mjs.map
